<template>
    <div class="informationDetail">
        <div class="Con-informationDetail">
            <el-breadcrumb class="tip" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/information' }">资讯</el-breadcrumb-item>
                <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
            </el-breadcrumb>

            <article-detail :artDetail='Detail' :pageType="pageType"></article-detail>

            <return-top></return-top>
        </div>
    </div>
</template>

<script>
import ArticleDetail from '@/components/information/articleDetail.vue'
import ReturnTop from '@/components/returnTop.vue'
export default {
  name: 'informationDetail',
  props: {

  },
  components: {
    ArticleDetail,
    ReturnTop

  },
  data () {
    return {
      pageType: 'information',
      Detail: {
        title: '第21届全国留学人员创业园网络年会在厦门召开',
        time: '发文时间：2018-12-04',
        from: '新华网',
        code: '李朋',
        reader: '阅读137',
        content: '11月27日，以“新时代、新趋势、新作为”为主题的第21届全国留学人员创业园网络年会在厦门召开。全国政协常委、港澳台侨委员会副主任，致公党中央副主席闫小培出席会议并讲话，厦门市人民政府副市长黄晓舟致辞。科技部、教育部、人力资源和社会保障部、致公党中央和福建省、厦门市当地有关部门领导，以及各地留学人员创业园、创业服务机构、留学人员企业代表等200余人参会。2020年，新冠肺炎疫情的突发对中国经济社会造成多方面影响，尤其中小企业受冲击较大。当前国际疫情和世界经济形势的严峻复杂，使得我国需要在世界经济循环系统中重新定位竞争优势，加快形成以国内大循环为主体、国内国际双循环相互促进的新发展格局。本次会议深入学习贯彻习近平新时代中国特色社会主义思想和党的十九届五中全会精神，结合疫情下国内外产业经济形势和留学人员发展环境变化与趋势，就“后疫情时代”留学人员创业园升级发展思路进行探讨交流。',
        img: require('@/assets/home/information6.png')
      }
    }
  },
  computed: {

  },
  created () {
    this.getinformationDetail()
  },
  mounted () {
    document.documentElement.scrollTop = 0
    this.$parent.activeIndex = '3'
  },
  methods: {
    // 获取资讯详情数据
    async getinformationDetail () {
      // const dataDetail = JSON.parse(sessionStorage.getItem('detailData'))
      // this.Detail = dataDetail

      const res = await this.$get(this.$url.information.informationDetail, {
        id: this.$route.query.id
      })

      const { code, msg, data } = res.data
      if (code === 200) {
        this.Detail = data
        // console.log(data)
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.informationDetail{
    width:100%;
    min-height: 90vh;
    background-color: #F5F5F5;
    overflow: hidden;
    margin-top: 7px;
}
.Con-informationDetail{
    min-height: 813px;
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    box-sizing: border-box;
    margin: 13px auto 100px;
    padding-top: 28px;
    border-radius: 8px;
    .tip{
        margin-left: 12px;
    }
    /deep/.el-breadcrumb__inner{
        color: #3f62da  !important;
    }
    /deep/.is-link{
        color: #000 !important;
        text-decoration: underline;
    }
}
</style>
